<template>
  <FileSave
      icon="mdi-plus"
      :maxWidth="500"
      :setTitle="setTitle"
      :fileData="fileData"
      @onFile="(response) => $emit('onFile', response)"
      v-bind="$attrs"
  />
</template>

<script>
  import Tickets from '@/services/tickets'

  import FileSave from '@/components/_Part/_Modal/_Save/File'

  export default {
    name: 'File',
    props: [
      'id'
    ],
    emits: [
      'onFile'
    ],
    components: {
      FileSave
    },
    methods: {
      setTitle() {
        return 'Súbor'
      },
      fileData(ItemForm) {
        return Tickets
          .uploadFile({
            id: this.id,
            data: ItemForm
          })
      }
    }
  }
</script>
